<template>
<div class="chapter">
<div class="inner_page">
<p class="fmcenter1"><a id="page_v">To General John Bell and Anna Hood and their descendants, living and dead, who, with dignity and grace, endured so much, for so long.</a></p><a id="page_v">
<p class="pagebreak">
</p></a><div class="image"><a id="page_v">
</a><p class="img"><a id="page_v"><img alt="Image" src="images/fig_001.jpg" style="max-width:100%;height:98%"/></a><a id="page_vi"></a></p><a id="page_vi">
<p class="caption">General John Bell Hood in a previously unpublished photograph, circa Richmond early 1864, before he left to command a corps in the Army of Tennessee.</p>
<p class="credit"><i>John Bell Hood Personal Papers</i></p>
</a></div><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication1.vue?ce653c7c